export default {
  Agriculture: [
    'Dairy Products',
    'Farming/Farming Equipment',
    'Feed/Grain/Milling',
    'Fertilizer/Agriculture Chemicals',
    'Field Crops/Soil Management',
    'Fishing',
    'Florists/Floriculture',
    'Food Processing/Distribution',
    'Forestry/Logging',
    'General Management',
    'Health Foods/Natural Foods',
    'Livestock/Breed',
    'Meats/Provisions',
    'Poultry/Poultry Products',
    'Produce (Fruits/Vegetables)',
    'Seed/Nursery Trade',
    'Senior Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Banking/Mortgage': [
    'Analyst',
    'Audit',
    'Banking',
    'Branch Manager',
    'Broker',
    'Credit',
    'General Management',
    'Lending',
    'Mergers/Acquisitions',
    'Senior Management',
    'Teller',
    'Title/Escrow',
    'Underwriter',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Biotech: [
    'Biological Research',
    'Chemical Research',
    'Clinical Research',
    'Environmental Testing/Analysis',
    'General Management',
    'Geological Testing/Analysis',
    'Mathematical Statistical Research',
    'Pharmacy/Pharmaceutical',
    'Senior Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Building Construction': [
    'Architect',
    'Boilermaker',
    'Building Inspection',
    'Carpentry/Framing',
    'Concrete/Masonry',
    'Contractor/General Contractor',
    'Electrical',
    'Equipment Operator',
    'Flooring/Tiling',
    'General Management',
    'HVAC',
    'Heavy Equipment',
    'Industrial Design',
    'Ironwork/Metal Fabrication',
    'Laborer',
    'Painting/Wallpapering',
    'Plumbing/Pipefitting',
    'Project Manager',
    'Roofing',
    'Senior Management',
    'Sheetrock/Plastering',
    'Site Superintendent',
    'Surveying',
    'Town/City Planning',
    'Welder',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Business: [
    'Analysis/Research',
    'Franchise',
    'Fundraising',
    'General Management',
    'Product Management',
    'Professional Services',
    'Senior Management',
    'Services/Support',
    'Strategic Planning/Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Creative/Design': [
    'Advertising',
    'Animation/Multimedia',
    'Architecture',
    'Creative Direction',
    'Fashion/Accessories',
    'General Management',
    'Graphic Arts/Illustration',
    'Industrial Design',
    'Interior Design',
    'Painting/Sculpting/Printmaking',
    'Photography/Videography',
    'Senior Management',
    'Web Design',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Customer Support/Client Services': [
    'Account Management',
    'Call/Contact Center',
    'Customer Service/Support',
    'Customer Training',
    'General Management',
    'Product Support',
    'Senior Management',
    'Technical Support',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Education: [
    'Administrator',
    'Admissions/Advising',
    'Corporate Training',
    'Early Childhood Care/Development',
    'Faculty',
    'Fitness/Sports Training',
    'General Management',
    'Librarian',
    'Provost',
    'Senior Management',
    'Special Education',
    'Student',
    'Teacher/Professor',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Engineering: [
    'Aerospace/Avionic Engineering',
    'Automotive Engineering',
    'Bio-Engineering',
    'CAD/Drafting',
    'Chemical Engineering',
    'Civil Structural Engineering',
    'Design Engineering',
    'Electrical/Electronics Engineering',
    'Energy/Nuclear Engineering',
    'Enterprise Software Implementation/Consulting',
    'Environmental/Geological Engineering',
    'Facilities Engineering',
    'Field',
    'General Management',
    'Industrial/Manufacturing Engineering',
    'Packaging Engineering',
    'Plant Engineering',
    'Semiconductors',
    'Senior Management',
    'Six Sigma/Black Belt/TQM',
    'System/Process Engineering',
    'Test Engineering',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Executives: [
    'Board Member',
    'CEO',
    'COO/Chief Operations Officer',
    'Chairman',
    'Chancellor',
    'Fellow',
    'General Manager',
    'Managing Partner',
    'Other CXO',
    'Owner/Co-owner',
    'Partner',
    'President',
    'Principal',
    'Treasurer',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Finance/Accounting': [
    'Accounting',
    'Account Payable/Receivable',
    'Analyst',
    'Audit',
    'Bookkeeping',
    'CFO/Chief Financial Officer',
    'Collections',
    'Controller',
    'Corporate',
    'Credit Review/Analysis',
    'Financial Analysis/Research',
    'Financial Control',
    'Financial Planning/Advising',
    'Financial Product Sales/Brokerage',
    'Fund Accounting',
    'General Management',
    'Investment Banking/Sales and Trading',
    'Investment Management',
    'Private Equity',
    'Procurement',
    'Registered Investment Advisor',
    'Registered Rep',
    'Risk Management/Compliance',
    'Securities Analysis/Research',
    'Senior Management',
    'Tax Assessment/Collections',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Food Services/Hospitality': [
    'General Management',
    'Guest Services/Concierge',
    'Guide',
    'Host/Hostess',
    'Hotel/Lodging Management',
    'Restaurant Management',
    'Senior Management',
    'Waiter/Waitress',
    'Winery',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Human Resources': [
    'CHRO/Chief Human Resource Officer',
    'CLO/Chief Learning Officer',
    'CPO/Chief People Officer',
    'Compensation/Benefit Policy',
    'Corporate Communications',
    'Corporate Development',
    'Diversity Management/EEO/Compliance',
    'General Management',
    'HR Systems Administration',
    'Learning/Training',
    'Organizational Development',
    'Payroll/Benefits',
    'Recruiting',
    'Senior Management',
    'Talent Management',
    'Wellness',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'IT/Computers/Electronics': [
    'Business Intelligence/Data Science',
    'CDO/Chief Data Officer',
    'CIO/Chief Information Officer',
    'CISO/Chief Information Security Officer',
    'CSO/Chief Security Officer',
    'CTO/Chief Technology Officer',
    'Computer Engineering',
    'Computer/Network Security',
    'Cyber Security/Information Security',
    'Data Center',
    'Database Management',
    'Desktop Systems',
    'Devops & Application Management',
    'Enterprise Software Implementation',
    'General Management',
    'Hardware',
    'IT Infrastructure',
    'IT Project Management',
    'IT Systems Management',
    'Network/Server Administration',
    'Product Development',
    'QA & Testing',
    'Senior Management',
    'Software Development',
    'Software Engineer',
    'Software/System Architecture',
    'Storage Management',
    'System Admin/Desktop Support',
    'System Analysis',
    'Telecommunications & Wireless',
    'Web Developer',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Installation/Maintenance/Repair': [
    'Automotive/Vehicle',
    'Computer/Electronics',
    'Electrician',
    'Equipment',
    'Facilities',
    'General Management',
    'HVAC',
    'Janitorial/Cleaning',
    'Locksmith',
    'Oil Rig/Pipeline',
    'Plumbing/Pipefitting',
    'Senior Management',
    'Telecommunications',
    'Wire/cable',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Insurance: [
    'Actuarial Analysis',
    'Appraiser',
    'Audit',
    'Bookkeeping',
    'Claims Review/Adjusting',
    'Employee Benefits Broker/Consultant',
    'Financial Analysis/Research',
    'General Management',
    'Independent Insurance Agent',
    'Insurance Brokerage',
    'Investment Management',
    'Planning/Advising',
    'Policy Underwriting',
    'Risk Management/Compliance',
    'Senior Management',
    'Third Party Administrator',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Journalism/Media/Entertainment': [
    'Author',
    'Digital Content Development',
    'Documentation/Technical Writing',
    'Editing/Proofreading',
    'General Management',
    'Journalism',
    'Motion/Talk/Sound/Commercial Pictures',
    'Music/Composing',
    'Public Relations',
    'Radio/Broadcasting',
    'Senior Management',
    'Translation/Interpretation',
    'Video/Television',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Legal: [
    'Arbitrator/Mediator',
    'CCO/Chief Compliance Officer',
    'Contracts Administration',
    'General Management',
    'In-House Attorney',
    'Judge/Magistrate',
    'Jury Consultant',
    'Labor/Entertainment',
    'Law Firm Attorney',
    'Legal Operations',
    'Litigation',
    'Paralegal',
    'Patent/IP',
    'Real Estate',
    'Regulatory/Compliance',
    'Secretary',
    'Senior Management',
    'Tax Lawyer',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Logistics/Transportation': [
    'Car/Truck/Van/Bus Driving',
    'Cargo/Baggage Handling',
    'General Management',
    'Hazardous Material Handling',
    'Import/Export Administration',
    'Inventory Planning/Management',
    'Logistics',
    'Merchandise Planning/Buying',
    'Piloting: Air/Marine',
    'Public Transportation',
    'Purchasing',
    'Recreational Vehicles',
    'Senior Management',
    'Shipping/Receiving/Warehousing',
    'Supply Chain Management',
    'Train/Rail Operator',
    'Vehicle Dispatch/Routing/Scheduling',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Manufacturing/Production/Operations': [
    'Assembly/Assembly Line',
    'Equipment',
    'General Management',
    'Machining/CNC',
    'Materials',
    'Metal Fabrication/Welding',
    'Mold Making/Casting',
    'Operations',
    'Packaging',
    'Planning/Advising',
    'Plant Management',
    'Production',
    'Scientific/Technical Production',
    'Senior Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Marketing: [
    'Affiliate Marketing',
    'Brand/Product Marketing',
    'Channel Marketing',
    'CMO/Chief Marketing Officer',
    'Content Marketing',
    'Copy Writing/Editing',
    'Corporate Marketing',
    'Creator/Influencer',
    'Demand/Lead Generation',
    'Digital Marketing',
    'Direct Marketing',
    'Events/Promotional Marketing',
    'Fundraising',
    'General Management',
    'Investor/Public/Media Relations',
    'Market Research',
    'Marketing Communications',
    'Marketing Operations',
    'Marketing Production/Traffic',
    'Marketing Technology',
    'Media Planning/Buying',
    'Product Management',
    'Public Relations',
    'SEO',
    'Senior Management',
    'Social Media',
    'Telemarketing',
    'Visual/Display Marketing',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Medical and Health': [
    'Chiropractic',
    'Dental Assistant/Hygienist',
    'Dental Practitioner',
    'EMT/Paramedic',
    'General Management',
    'Healthcare Aid',
    'Home Health',
    'Hospital/Clinic',
    'Internal Medicine',
    'Laboratory/Pathology',
    'Medical Device',
    'Medical Imaging',
    'Medical Practitioner',
    'Medical Therapy/Rehab Services',
    'Mental Health',
    'Neurology',
    'Nursing/Hospital',
    'Nutrition/Dieting',
    'Occupational Therapy',
    'Ophthalmology',
    'Orthotist',
    'Pharmacy/Pharmaceutical',
    'Physical Therapy',
    'Public Health',
    'Radiology',
    'Research',
    'Senior Management',
    'Social Service',
    'Speech Pathology',
    'Sports Medicine',
    'Veterinary/Animal Care',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Quality Assurance/Safety': [
    'Environmental Protection',
    'Food Safety/Inspection',
    'Fraud Investigation',
    'General Management',
    'ISO Certification',
    'Occupational Health/Safety',
    'Process Improvement',
    'Production Quality',
    'Quality Systems',
    'Senior Management',
    'Vehicle Inspection',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Real Estate': [
    'Agent/Broker',
    'Appraising',
    'General Management',
    'Investor',
    'Leasing/Acquisition',
    'Legal Operations',
    'Property Manager',
    'Senior Management',
    'Title Officer',
    'Underwriter',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Retail: [
    'Cashier',
    'Event Ticketing',
    'Merchandise Planning/Buying',
    'Retail Services',
    'Retail/Counter Sales',
    'Senior Management',
    'Store/Branch Management',
    'Visual/Display Merchandising',
    'Wholesale/Reselling',
    'eCommerce',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Sales: [
    'Event Ticketing',
    'Agent/Broker',
    'Business Development',
    'Field Service',
    'General Management',
    'International Sales',
    'Media/Advertising Sales',
    'Product Sales',
    'Sales',
    'Sales Operations',
    'Senior Management',
    'Telesales',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Public Safety and Security Services': [
    'Event Ticketing',
    'Airport Security/Screening',
    'Correctional Officer',
    'Customer/Immigration',
    'Firefighting/Rescue',
    'General Management',
    'Military Combat',
    'Police/Law Enforcement',
    'Security Guard',
    'Security Intelligence/Analysis',
    'Senior Management',
    'Store Security/Loss Prevention',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Strategy and Consulting': [
    'HR Consulting',
    'Management Consulting',
    'OPerations Consulting',
    'Strategy',
    'Strategy Consulting',
    'Technology Consulting',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Other: ['Other'].map((item) => ({ label: item, value: item })),
};
